export default __webpack_public_path__ + "static/media/Stokes.0e4375cc.png";